export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по продажам через переписку',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер и консультант с более чем 18-летним опытом в обучении продажам, переговорам и коммуникации',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по продажам через переписку. Обучение менеджеров продавать в Telegram, WhatsApp, Bitrix24, CRM и e-mail. Реальные кейсы, практика и сопровождение внедрения.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение продажам через переписку',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Как проходит тренинг по продажам через переписку?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Тренинг начинается с диагностики: изучаем реальные переписки команды в Telegram, WhatsApp, CRM, e-mail. Затем разрабатываем адаптированную программу. Сам тренинг на 80% состоит из практики: разбираем конкретные диалоги участников, отрабатываем скрипты, учимся управлять перепиской. После — сопровождение и разбор новых диалогов.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить переписке опытных менеджеров?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. Опытные менеджеры часто имеют устоявшиеся привычки, которые не работают в переписке. Мы показываем разницу между телефонной коммуникацией и текстовой, даём инструменты адаптации. Опытные сотрудники обычно быстрее внедряют новые техники, потому что у них уже есть база продаж.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы с Telegram?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, Telegram — один из основных каналов в программе. Разбираем специфику: неформальный тон, скорость ответа, использование голосовых сообщений, работу с группами и каналами. Учим выстраивать доверие в мессенджере и доводить диалог до сделки.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли разобрать реальные переписки нашей компании?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Это ключевой элемент методологии. До тренинга мы запрашиваем доступ к перепискам и анализируем их. Во время обучения участники разбирают именно свои диалоги — с конкретными клиентами, возражениями и ошибками. Это в десятки раз эффективнее абстрактных примеров.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли с CRM-системами (Bitrix24, AmoCRM)?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. Обучаем работе в чатах Bitrix24, AmoCRM и других CRM. Разбираем, как вести клиента внутри системы, не терять историю переписки, правильно фиксировать договорённости и управлять воронкой через переписку.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли сопровождение после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, посттренинговое сопровождение — обязательный элемент. Мы продолжаем разбирать переписки участников, даём обратную связь, поддерживаем в чате. Без сопровождения эффективность тренинга падает на 70–80% уже через месяц.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как быстро появляются первые результаты?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Первые изменения видны уже во время тренинга — участники видят свои ошибки и сразу применяют новые техники. Устойчивые результаты появляются через 2–4 недели регулярной практики с сопровождением. Измеримые бизнес-показатели (конверсия, средний чек) — через 1–3 месяца.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить удалённую команду онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, онлайн-формат полностью адаптирован для удалённых команд. Живые сессии через видеосвязь, разбор переписок через демонстрацию экрана, работа в группах. Онлайн-тренинг по переписке даже органичнее очного — мы сразу работаем в цифровой среде.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли обучение для B2B-компаний?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. В B2B переписка играет ключевую роль: КП, коммерческие предложения, согласования, работа с закупщиками — всё идёт через переписку. Обучаем вести сложные B2B-диалоги: аргументировать ценность, работать с ЛПР, сопровождать длинный цикл сделки.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли обучение для B2C?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. В B2C переписка стала основным каналом продаж: Instagram Direct, WhatsApp, чаты сайта, Telegram. Обучаем быстро обрабатывать обращения, вести клиента к покупке в чате, работать с возражениями и повышать средний чек через переписку.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли адаптировать программу под нашу компанию?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Каждая программа создаётся индивидуально. Мы изучаем ваш продукт, цикл сделки, каналы коммуникации, уровень команды. Адаптируем кейсы, скрипты и упражнения под реальные диалоги ваших менеджеров. Никаких шаблонных программ.',
        },
      },
      {
        '@type': 'Question',
        name: 'Обучаете ли вы работе с WhatsApp?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, WhatsApp — один из ключевых каналов программы. Разбираем особенности: неформальный стиль, работу с медиафайлами, голосовые сообщения, групповые чаты. Учим выстраивать продающий диалог без давления и шаблонов.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по продажам через переписку',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku', name: 'Тренинг по продажам через переписку' },
      },
    ],
  };

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, консультант',
    description: 'Бизнес-тренер и консультант с более чем 18-летним опытом. Провёл более 450 тренингов и 100 корпоративных проектов. Специализация: продажи, переговоры, коммуникация. Работает с компаниями Беларуси, России, Казахстана и Израиля.',
    url: 'https://sivko.by/',
    sameAs: [
      'https://t.me/a_sivko',
      'https://business-training.by/',
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }} />
    </>
  );
}